import React from 'react';
import { Container } from '../style-comps/Common.styles';
import {
    LeftContainer,
    Title,
    Subtitle,
    RightContainer,
    TabWrapper,
} from '../style-comps/Review.styles';

import ReviewCard from '../components/ReviewCard';
import ListingCard from '../components/ListingCard';

const Review = () => {


    const reviewData = [
        { label: 'Overall', score: 4.68 },
        { label: 'Accuracy', score: 2.33 },
        { label: 'Checkin', score: 4.67 },
        { label: 'Cleanliness', score: 3.88 },
        { label: 'Communication', score: 4.68 },
        { label: 'Location', score: 4.11 },
        { label: 'Value', score: 4.92 },
        { label: 'Reviews', score: 4.47 },
    ];

    // Data for Listing component
    const contractData = [
        {
            Created: '20/11/2024',
            Property: 'NAL015 2R',
            Reservation: 'Matthew Strano HM2X35FYTQ',
            Overall: '3.99',
            PublicReviews: 'I had a pleasurable stay and would recommend. The property was well ...',
            PrivateReviews: 'You are doing an amazing job',
        },
        {
            Created: '20/11/2024',
            Property: 'NAL015 2R',
            Reservation: 'Matthew Strano HM2X35FYTQ',
            Overall: '3.99',
            PublicReviews: 'I had a pleasurable stay and would recommend. The property was well ...',
            PrivateReviews: 'You are doing an amazing job',
        },
        {
            Created: '20/11/2024',
            Property: 'NAL015 2R',
            Reservation: 'Matthew Strano HM2X35FYTQ',
            Overall: '3.99',
            PublicReviews: 'I had a pleasurable stay and would recommend. The property was well ...',
            PrivateReviews: 'You are doing an amazing job',
        },

    ];

    const tableHeaders = ["Created", "Property", "Reservation", "Overall", "Public Reviews", "Private Reviews"];
    const tableColumns = ["Created", "Property", "Reservation", "Overall", "PublicReviews", "PrivateReviews"];

    return (
        <>
            <TabWrapper>
                <Container>
                    <LeftContainer>
                        <Title>Review</Title>
                        <Subtitle>You can find your properties here.</Subtitle>
                    </LeftContainer>
                    {/* Right-side card grid */}
                    <RightContainer>
                        {/* Render ReviewCards */}
                        {reviewData.map((data, index) => (
                            <ReviewCard key={index} label={data.label} score={data.score} />
                        ))}
                    </RightContainer>
                </Container>
                <Container>
                    <ListingCard
                        title="Review"
                        headers={tableHeaders}
                        columns={tableColumns}
                        data={contractData}
                        rowsPerPage={2}
                    />
                </Container>
            </TabWrapper >
        </>);
};

export default Review;
